export default {
    methods: {
        milliseconds: timeStr => {
            const timePart = timeStr.split(':');
            const [hrs, min, sec] = timePart;
            return (
                (Number(hrs) * 60 * 60 + Number(min) * 60 + Number(sec)) * 1000
            );
        },
    },
};
